import { isDefined } from '@philips-emr/tws-utils';

function getError(message: string): Error {
  return new Error(`[Session Storage Service]: ${message}`);
}

function checkKey(key: string): void {
  if (!key) {
    throw getError('Trying to set an item with an empty key.');
  }
}

function convertToJSON(value: any): string {
  return JSON.stringify(value, null, 0);
}

function convertFromJSON(value: string | null): any {
  if (!value) {
    return value;
  }

  return JSON.parse(value);
}

function clear(): void {
  sessionStorage.clear();
}

function getItem(key: string): any {
  checkKey(key);

  const item = sessionStorage.getItem(key);

  return convertFromJSON(item);
}

function removeItem(key: string): void {
  checkKey(key);

  sessionStorage.removeItem(key);
}

function setItem(key: string, value: any): void {
  checkKey(key);

  if (!isDefined(value)) {
    throw getError('Trying to set an undefined item.');
  }

  const stringified = convertToJSON(value);
  sessionStorage.setItem(key, stringified);
}

export default {
  clear, getItem, removeItem, setItem,
};

export { clear, getItem, removeItem, setItem };
